export default {
    name: 'ERROR',
    onEnter: () => {},
};
